import { render } from "./ordinaryContainer.vue?vue&type=template&id=9ec3c9ce&scoped=true"
import script from "./ordinaryContainer.vue?vue&type=script&lang=js"
export * from "./ordinaryContainer.vue?vue&type=script&lang=js"

import "./ordinaryContainer.vue?vue&type=style&index=0&id=9ec3c9ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ec3c9ce"]])

export default __exports__